import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Reference } from "../reference";
import { ReferenceService } from "../reference.service";

@Component({
  selector: "reference-image",
  styleUrls: ["./reference-image.component.css"],
  templateUrl: "./reference-image.component.html"
})
export class ReferenceImageComponent implements OnInit {
  @Input()
  public reference!: Reference;

  @ViewChild('modal', { static: false })
  public modalRef!: ElementRef;

  public image!: string | ArrayBuffer | null;
  public thumbnail!: string | ArrayBuffer | null;

  public loading = false;
  public modalLoading = false;

  constructor(private modalService: NgbModal, private referenceService: ReferenceService) {

  }

  ngOnInit(): void {
    if(this.reference.isbn == "") {  
      return;
    }

    this.loading = true;

    this.referenceService.loadImageInReference(this.reference, { imageMaxWidth: 35 })
      .subscribe({
        complete: () => this.loading = false,
        error: _ => this.loading = false,
        next: thumbnail => this.thumbnail = thumbnail
      });
  }

  public openModal() {
    this.modalLoading = true;
    this.modalService.open(this.modalRef, { size: "lg" });
    this.referenceService.loadImageInReference(this.reference, { imageMaxWidth: 400 })

      .subscribe({
        complete: () => this.modalLoading = false,
        error: _ => this.modalLoading = false,
        next: image => this.image = image
      });
  }
}